import React from 'react';
import { IconArrowBack, IconArrowForward } from '@noths/polaris-client-ribbons-design-system';

import { PRODUCT_IMAGES_TABPANEL_CONTAINER_ID } from 'src/components/organisms/ProductImagesCarousel/constants/elementIds';
import * as styles from './ImageNavigationButtons.styles';

interface ImageNavigationButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const PreviousButton = ({ onClick }: ImageNavigationButtonProps) => {
  return (
    <button
      aria-controls={PRODUCT_IMAGES_TABPANEL_CONTAINER_ID}
      aria-label="Show previous image"
      css={[styles.navigationButton, styles.prevNavigationButton]}
      onClick={onClick}
      type="button"
    >
      <IconArrowBack color="var(--neutral-black-base)" height={24} width={24} />
    </button>
  );
};

export const NextButton = ({ onClick }: ImageNavigationButtonProps) => {
  return (
    <button
      aria-controls={PRODUCT_IMAGES_TABPANEL_CONTAINER_ID}
      aria-label="Show next image"
      css={[styles.navigationButton, styles.nextNavigationButton]}
      onClick={onClick}
      type="button"
    >
      <IconArrowForward color="var(--neutral-black-base)" height={24} width={24} />
    </button>
  );
};
